import { Landing, Overview } from ".";
export default {
  path: "",
  childRoutes: [
    { path: "overview", component: Overview, isIndex: false },
    { path: "", component: Overview, isIndex: true },
  ],
};
